import { BaseChangeLog } from '@models/next/ChangeLog';
import { Payee, PaymentDetails, PaymentSlip } from '@models/next/PaymentSlip';
import { z } from 'zod';

export const PaymentSlipLog = z.discriminatedUnion('edited_field', [
  BaseChangeLog.extend({
    edited_field: z.literal('payee.name_ja'),
    before_value: Payee.shape.name_ja,
    after_value: Payee.shape.name_ja,
  }),
  BaseChangeLog.extend({
    edited_field: z.literal('payee.name_en'),
    before_value: Payee.shape.name_en,
    after_value: Payee.shape.name_en,
  }),
  BaseChangeLog.extend({
    edited_field: z.literal('payee.fc_no'),
    before_value: Payee.shape.fc_no,
    after_value: Payee.shape.fc_no,
  }),
  BaseChangeLog.extend({
    edited_field: z.literal('payee.principal_name'),
    before_value: Payee.shape.principal_name,
    after_value: Payee.shape.principal_name,
  }),
  BaseChangeLog.extend({
    edited_field: z.literal('payee.phone'),
    before_value: Payee.shape.phone,
    after_value: Payee.shape.phone,
  }),
  BaseChangeLog.extend({
    edited_field: z.literal('payee.email'),
    before_value: Payee.shape.email,
    after_value: Payee.shape.email,
  }),
  BaseChangeLog.extend({
    edited_field: z.literal('payment_type'),
    before_value: PaymentSlip.shape.payment_type,
    after_value: PaymentSlip.shape.payment_type,
  }),
  BaseChangeLog.extend({
    edited_field: z.literal('deadline'),
    before_value: PaymentSlip.shape.cutoff_date,
    after_value: PaymentSlip.shape.cutoff_date,
  }),
  BaseChangeLog.extend({
    edited_field: z.literal('payment_date'),
    before_value: PaymentSlip.shape.payment_date,
    after_value: PaymentSlip.shape.payment_date,
  }),
  BaseChangeLog.extend({
    edited_field: z.literal('invoice_no'),
    before_value: PaymentSlip.shape.invoice_no,
    after_value: PaymentSlip.shape.invoice_no,
  }),
  BaseChangeLog.extend({
    edited_field: z.literal('invoice_date'),
    before_value: PaymentSlip.shape.invoice_date,
    after_value: PaymentSlip.shape.invoice_date,
  }),
  BaseChangeLog.extend({
    edited_field: z.literal('invoice_file'),
    before_value: PaymentSlip.shape.invoice_file,
    after_value: PaymentSlip.shape.invoice_file,
  }),
  BaseChangeLog.extend({
    edited_field: z.literal('memo'),
    before_value: PaymentSlip.shape.memo,
    after_value: PaymentSlip.shape.memo,
  }),
  BaseChangeLog.extend({
    edited_field: z.literal('payment_details'),
    before_value: PaymentDetails.array(),
    after_value: PaymentDetails.array(),
  }),
]);

export type PaymentSlipLog = z.infer<typeof PaymentSlipLog>;

export type PaymentSlipLogFormatters = {
  [K in PaymentSlipLog['edited_field']]?: (
    value: Extract<PaymentSlipLog, { edited_field: K }>['before_value'],
  ) => string;
};
